<div class="main-container" >
    <div class="left-side-counts">
        <div class="analytics-card">
            <svg width="70" height="50" viewBox="0 0 85 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.818115" width="85" height="60" rx="30" fill="#2D9628" fill-opacity="0.15"/>
                <path d="M45.4165 32.9041C49.6315 31.1535 54.7891 33.0648 56.9462 38.6383C57.8622 41.0047 55.7648 43.2139 53.2275 43.2139H47.9686M40.3123 23.5264C40.3123 26.1441 38.1903 28.266 35.5727 28.266C32.9551 28.266 30.8331 26.1441 30.8331 23.5264C30.8331 20.9088 32.9551 18.7869 35.5727 18.7869C38.1903 18.7869 40.3123 20.9088 40.3123 23.5264ZM40.5139 43.2139H31.1524C28.615 43.2139 26.5184 41.0006 27.435 38.6345C30.7193 30.1571 40.947 30.1571 44.2312 38.6345C45.1479 41.0006 43.0512 43.2139 40.5139 43.2139ZM53.8019 23.5264C53.8019 26.1441 51.6799 28.266 49.0623 28.266C46.4446 28.266 44.3227 26.1441 44.3227 23.5264C44.3227 20.9088 46.4446 18.7869 49.0623 18.7869C51.6799 18.7869 53.8019 20.9088 53.8019 23.5264Z" stroke="#479A3F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
                <div>{{ "DASHBOARD.OPERATIONS_ANALYTICS.CUSTOMERS_COUNT" | translate }}</div>
                <div>{{ customerCount | number }}</div>
            </div>
        </div>
        <div class="analytics-card">
            <svg width="70" height="50" viewBox="0 0 85 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.194824" width="85" height="60" rx="30" fill="#DC7032" fill-opacity="0.15"/>
                <path d="M36.0002 26.5457L37.6408 27.6395L40.3702 24.0002M45.1367 25.8199H48.7825M36.0002 35.2974L37.6408 36.3911L40.3702 32.7519M54.5312 29.1011V22.5386C54.5312 20.1223 52.5726 18.1636 50.1562 18.1636H34.8437C32.4275 18.1636 30.4688 20.1223 30.4688 22.5386V37.8511C30.4688 40.2674 32.4275 42.2261 34.8437 42.2261H41.4062M53.2498 40.934C51.5412 42.6424 48.7713 42.6424 47.0627 40.934C45.3541 39.2254 45.3541 36.4553 47.0627 34.7467C48.7713 33.0381 51.5412 33.0381 53.2498 34.7467C54.9584 36.4553 54.9584 39.2254 53.2498 40.934ZM53.2498 40.934L55.9896 43.6736" stroke="#D07848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
                <div >{{ "DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS_COUNT" | translate }}</div>
                <div>{{ counts?.surveysCount | number }}</div>
            </div>
        </div>
        <div class="analytics-card">
            <svg width="70" height="50" viewBox="0 0 85 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.571533" width="85" height="60" rx="30" fill="#065481" fill-opacity="0.15"/>
                <path d="M46.2467 36.567C51.6274 36.567 55.9893 32.2051 55.9893 26.8245C55.9893 25.701 55.7991 24.6218 55.4491 23.6175L51.4928 27.5739C49.8372 29.2295 47.1529 29.2295 45.4974 27.5739C43.8418 25.9183 43.8418 23.2341 45.4974 21.5786L49.4538 17.6222C48.4496 17.2722 47.3704 17.082 46.2467 17.082C40.8662 17.082 36.5043 21.4439 36.5043 26.8245C36.5043 28.1531 36.7703 29.4195 37.2518 30.5735L30.0853 37.8448C28.6831 39.2675 28.6914 41.555 30.1039 42.9674C31.5163 44.3798 33.8038 44.3881 35.2265 42.986L42.4978 35.8196C43.6518 36.3011 44.9182 36.567 46.2467 36.567Z" stroke="#5098CC" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <div>
                <div>{{ "DASHBOARD.OPERATIONS_ANALYTICS.INSTALLATIONS_COUNT" | translate }}</div>
                <div>{{ counts?.installationsCounts | number }}</div>
            </div>
        </div>
    </div>
    <div class="right-content">
        <!-- Period buttons -->
        <div class="d-flex graph-filters">
            <div class="period-buttons">
                <div (click)="setGraphType('Daily')"
                    [ngClass]="{ 'selected-period': graphType === 'Daily', 'unselected-period': graphType !== 'Daily' }">
                {{ "COMMON.DAILY" | translate }}
                </div>
                
                <div (click)="setGraphType('Monthly')"
                    [ngClass]="{ 'selected-period': graphType === 'Monthly', 'unselected-period': graphType !== 'Monthly' }">
                {{ "COMMON.MONTHLY" | translate }}
                </div>
                
                <div (click)="setGraphType('Yearly')"
                    [ngClass]="{ 'selected-period': graphType === 'Yearly', 'unselected-period': graphType !== 'Yearly' }">
                {{ "COMMON.YEARLY" | translate }}
                </div>
            </div>
            <div class="ms-auto d-flex align-items-center">
                <div class="filter-icon">
                    <svg (click)="toggleFilterPopup()" width="22" height="22" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.70123 20.3839V14.1314M5.70123 10.3799V3.87695M11.9998 20.1337V12.8804M11.9998 9.12903V4.12695M18.2984 20.3835V16.1319M18.2984 12.3807V3.87695M3.74609 13.8814H7.74982M9.99982 9.3789H13.9998M16.2498 15.8819H20.2498" stroke="#17171A" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="filter-popup" *ngIf="isFilterPopupVisible">
                        <div>
                            Bars
                        </div>
                        <label>
                            <input type="checkbox"  
                                [checked]="!chart?.chart?.getDatasetMeta(0)?.hidden"
                                (change)="toggleDatasetVisibility('Surveys')"/>
                            {{ 'DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS' | translate }}
                        </label>
                        <label>
                            <input type="checkbox" 
                                [checked]="!chart?.chart?.getDatasetMeta(1)?.hidden"
                                (change)="toggleDatasetVisibility('Installations')"/>
                            {{ 'DASHBOARD.OPERATIONS_ANALYTICS.INSTALLATIONS' | translate }}
                        </label>
                    </div>
                </div>
                <div class="date">
                    <span class="arrow left-arrow" (click)="increasePage(1)">
                        <svg
                            class="primary-color"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.2431 6.34317L14.8288 4.92896L7.75781 12L14.8289 19.0711L16.2431 17.6569L10.5862 12L16.2431 6.34317Z"
                            />
                        </svg>
                    </span>
                    <span class="value"
                    >{{ lineGraphData?.labels[0] }} -
                    {{ lineGraphData?.labels[lineGraphData.labels.length - 1] }}</span
                    >
                    <span class="arrow right-arrow" (click)="increasePage(-1)">
                        <svg
                            class="primary-color"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 6.41422L9.4143 5L16.4853 12.0711L9.4143 19.1422L8 17.7279L13.6569 12.0711L8 6.41422Z"
                            />
                        </svg>
                    </span>
                </div>
            </div>
        </div>
        
        <div class="chart-container">
            <canvas baseChart
                    [data]="lineGraphData"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    [type]="'bar'">
            </canvas>
        </div>
    </div>


</div>